// swiper
const swiper = new Swiper('.text-swiper-slider', {
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    pagination: {
        el: '.text-slider-pagination',
        clickable: true,
    },
});
